import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/i18n'
import App from './App.tsx'
import { InitialLoadingShell } from '@/components/ui/initial-loading-shell'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<InitialLoadingShell />}>
      <App />
    </Suspense>
  </StrictMode>,
)
